// src/app/shared/model/language-flags.ts

export const LANGUAGE_FLAGS: Record<string, string> = {
  Arabic: '🇸🇦',
  Chinese: '🇨🇳',
  Dutch: '🇳🇱',
  English: '🇬🇧',
  French: '🇫🇷',
  German: '🇩🇪',
  Hindi: '🇮🇳',
  Italian: '🇮🇹',
  Japanese: '🇯🇵',
  Korean: '🇰🇷',
  Polish: '🇵🇱',
  Portuguese: '🇵🇹',
  Russian: '🇷🇺',
  Spanish: '🇪🇸',
  Swedish: '🇸🇪',
  Turkish: '🇹🇷',
};
